




export default angular.module('sharable-dashboard.hash-service', [
]).factory('hashService', [function() {
    return {
        hash: function(str) {
            if(typeof str === 'object') {
                str = angular.toJson(str);
            }
            var hash = 0, char;
            if (str.length == 0) return hash;
            for (var i = 0; i < str.length; i++) {
                char = str.charCodeAt(i);
                hash = ((hash<<5)-hash)+char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        }
    }
}]);